import React from 'react';

/* External */
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

/* Project */
import { getIdentifier } from 'utils/services/versionHistory';
import { withTranslation } from 'react-i18next';
import { getLocalDate } from 'utils/DateFormat';
import SkeletonTable from 'commons/components/SkeletonTable';
import { ModelNames } from 'utils/ModelNames';
import { truthty } from 'utils/functions';
import { useTranslation } from 'react-i18next';

function RowTable(props) {
  const { t } = useTranslation();
  const {
    item: { id, changes, recordId, eventType, modelName, userId, createdAt },
    users,
    StyledTableRow,
    actionTypes
  } = props;

  const timestamp = getLocalDate(createdAt).localeDateTime.replaceAll('-', '/').replaceAll(',', '');

  let username = Object.values(users).find((user) => user.id === userId);
  username = username?.id ? username.email : t('versionHistory.noIdentified');

  const attrChanged = JSON.parse(changes);
  delete attrChanged.createdAt;
  delete attrChanged.updatedAt;

  return (
    <StyledTableRow key={id}>
      <TableCell align="center">{timestamp}</TableCell>
      <TableCell align="center">
        {getIdentifier(recordId, modelName, attrChanged, t('identifier:name'))}
      </TableCell>
      <TableCell align="center">{ModelNames[modelName]}</TableCell>
      <TableCell align="center">{actionTypes[eventType]}</TableCell>
      <TableCell align="center">{username}</TableCell>
    </StyledTableRow>
  );
}

function List(props) {
  const {
    objects,
    loading,
    pagination,
    versionHistoriesList,
    handleChangeRowsPerPage,
    handleChangePage,
    t,
  } = props;

  const { users } = objects;

  const columns = [
    { id: 'createdAt', label: t('versionHistory.createdAt') },
    { id: 'identifier', label: t('versionHistory.identifier') },
    { id: 'modelName', label: t('versionHistory.modelName') },
    { id: 'eventType', label: t('versionHistory.eventType') },
    { id: 'userId', label: t('versionHistory.userId') },
    // { id: "dropDown", label: "" },
  ];

  const actionTypes = {
    create: 'Creación',
    update: 'Actualización',
    destroy: 'Eliminación',
  };

  // const stateChanges = ['Anterior', 'Actual']

  const StyledTableCell = withStyles(() => ({
    head: {
      backgroundColor: '#358a7c',
      color: 'white',
    },
  }))(TableCell);

  const StyledTableRow = withStyles(() => ({
    root: {
      '&:nth-of-type(even)': {
        backgroundColor: 'white',
      },
    },
  }))(TableRow);

  const emptyContainer = [...Array(pagination.rowsPerPage)].map((row, index) => (
    <StyledTableRow>
      <TableCell align="center" colSpan={columns.length}>
        {index === 4 && t('versionHistory.noResults')}
      </TableCell>
    </StyledTableRow>
  ));

  const tableContainer = truthty(versionHistoriesList)
    ? Object.values(versionHistoriesList)
      .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
      .map((versionHistory) => (
        <RowTable
          item={versionHistory}
          users={users}
          StyledTableRow={StyledTableRow}
          actionTypes={actionTypes}
          t={t}
        />
      ))
    : emptyContainer;

  return (
    <Grid item container>
      <TableContainer>
        <Table stickyHeader style={{ border: 'none' }}>
          <TableHead>
            <TableRow key="table-head-1">
              {columns.map((column) => (
                <StyledTableCell key={`table-head-${column.id}`} align="center">
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <SkeletonTable times={pagination.rowsPerPage} columns={columns.length} />
            ) : (
              tableContainer
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={pagination.count}
          rowsPerPage={pagination.rowsPerPage}
          page={pagination.page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={t('versionHistory.rowsPerPage')}
        />
      </TableContainer>
    </Grid>
  );
}

export default withTranslation()(List);
